<template>
  <div>
    <MainContent 
      v-if="page >= 1 && !isFilterActive && (loading || mainContent)" 
      :content="loading ? {} : mainContent" 
    />

    <div v-if="(news.length > 0 || loading) && !isFilterActive" class="titulo mt-5">
      Novidades e Destaques
    </div>

    <div v-if="termoBusca && termoBusca.trim()" class="resultado-busca">
      Resultados para: <span class="termo-busca">{{ termoBusca.trim() }}</span>
    </div>

    <template v-if="news.length > 0">
      <NewsHighlights v-for="(item, index) in news" :key="'news-' + index" :obj="item" />
    </template>

    <template v-if="loading">
      <NewsHighlights v-for="i in 2" :key="'skeleton-' + i" :obj="{}" />
    </template>

    <div 
      class="d-none d-md-flex justify-content-center pagination-connection mb-3" 
      
    >
       <Pagination 
          v-show="!loading"
          :current-page="page" 
          :quantity-pages="totalPages"
          @change-page="onPaginationChange"
        />
    </div>

    <div v-if="isMobile && noMoreData && news.length > 0" class="text-center text-muted p-4">
      Não há mais conteúdos para carregar.
    </div>
  </div>
</template>

<script>
//import LastTrainingCard from "./LastTrainingCard.vue";
import MainContent from "./MainContent.vue";
import NewsHighlights from "./NewsHighlights.vue";
import ConnectionService from "../../../services/connection/ConnectionService";
import Pagination from "../../../components/base/Pagination.vue";

export default {
  props: {
    categoriaSelecionada: {
      type: [Number, String],
      default: null,
    },
    ordenacaoSelecionada: {
      type: Number,
      default: 1,
    },
    filtros: {
      type: Object,
      default: null,
    },
    termoBusca: {
      type: String,
      default: null,
    },
  },
  components: {
    //LastTrainingCard,
    MainContent,
    NewsHighlights,
    Pagination
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      loading: false,
      mainContent: null,
      news: [],
      lastTrainings: [],
      noMoreData: false,
      isMobile: window.innerWidth <= 768,
    };
  },
  mounted() {
    this.$emit('mudar-pagina', this.page); 
    this.fetchContents();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  watch: {
    categoriaSelecionada() { 
      this.resetPagination(); 
    },
    ordenacaoSelecionada() { 
      this.resetPagination(); 
    },
    filtros() { 
      this.resetPagination(); 
    },
    termoBusca() { 
      this.resetPagination(); 
    },
    
    // O watch da página agora só age se for Desktop
    page(newPage, oldPage) {
      if (!this.isMobile && newPage !== oldPage) {
        this.fetchContents();
        window.scrollTo(0, 0); // Scroll pro topo no desktop ao mudar página
      }
    },
  },
  computed: {
    isFilterActive() {
      return (
        (this.categoriaSelecionada != null && this.categoriaSelecionada !== 0) ||
        (this.ordenacaoSelecionada != null && this.ordenacaoSelecionada !== 1) ||
        this.filtros != null ||
        (this.termoBusca != null && this.termoBusca.trim() !== '')
      );
    },
  },
  methods: {
    onPaginationChange(newPage) {
      this.page = newPage;
      this.$emit('mudar-pagina', this.page); 
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    resetPagination() {
      this.page = 1;
      this.$emit('mudar-pagina', this.page);
      this.news = [];
      this.noMoreData = false;
      this.$nextTick(() => {
         this.fetchContents();
      });
    },
    handleScroll(event) {
        if (!this.isMobile || this.loading || this.noMoreData) return;

        // Se o scroll vier de uma div interna (event.target), ou do document
        const target = event.target === document ? document.documentElement : event.target;
        
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;

        // Se o elemento alvo do scroll não for o que queremos, 
        // tentamos ler do documentElement como fallback
        const currentScroll = scrollTop || window.pageYOffset || document.documentElement.scrollTop;
        const totalHeight = scrollHeight || document.documentElement.scrollHeight;
        const visibleHeight = clientHeight || window.innerHeight;

        if (currentScroll + visibleHeight >= totalHeight - 200) {
            this.page++;
            this.$emit('mudar-pagina', this.page); 
            this.fetchContents();
        }
    },
    async fetchContents() {
      if (this.loading) return;

      try {
        this.loading = true;

        const pageRequest = this.page - 1;
        const sizeRequest = this.perPage;

        const params = {
          page: pageRequest,
          size: sizeRequest,
          orderBy: this.ordenacaoSelecionada ?? 1,
        };
        if (this.categoriaSelecionada != null && this.categoriaSelecionada !== 0) {
          params.category = String(this.categoriaSelecionada);
        }
        if (this.termoBusca && this.termoBusca.trim()) {
          params.search = this.termoBusca.trim();
        }
        if (this.filtros) {
          params.onlyRequired = this.filtros.conteudoObrigatorio;
          if (this.filtros.filtroPeriodo === "personalizado") {
            if (this.filtros.dataInicio) {
              params.initialDate = this.filtros.dataInicio;
            }
            if (this.filtros.dataFim) {
              params.finalDate = this.filtros.dataFim;
            }
          } else if (this.filtros.filtroPeriodo === "semana" || this.filtros.filtroPeriodo === "mes") {
            params.period = this.filtros.filtroPeriodo;
          }
        }
        const items = await ConnectionService.getAll(params);
        this.totalPages = items.totalPages;

        const normalizedItems = Array.isArray(items)
          ? items
          : items?.content || items?.items || [];

        if (this.isMobile) {
          // MOBILE: Acumula os itens (Infinite Scroll)
          if (normalizedItems.length === 0) {
            this.noMoreData = true;
          } else {            
            if (this.page === 1 && !this.isFilterActive) {
              // Se for a primeira carga sem filtros, extrai o destaque
              this.mainContent = normalizedItems[0] || null;
              this.news = normalizedItems.slice(1);              
            } else {
              // Se for scroll infinito ou com filtro, apenas concatena
              this.news = [...this.news, ...normalizedItems];
            }
            if (normalizedItems.length < this.perPage) this.noMoreData = true;
          }          
        } else {
            this.mainContent = (this.page === 1 && !this.isFilterActive) ? normalizedItems[0] : null;
            this.news = (this.page === 1 && !this.isFilterActive) ? normalizedItems.slice(1) : normalizedItems;

            if (normalizedItems.length < this.perPage) {
              this.totalRows = (this.page - 1) * this.perPage + normalizedItems.length;
            } else {              
              this.totalRows = (this.page + 1) * this.perPage; 
            }
        }
      } catch (e) {
        console.error("Erro ao buscar conteúdos:", e);
        this.mainContent = null;
        this.news = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.titulo {
  color: #3d3f40;
  font-family: "Trebuchet MS";
  font-size: 20px;
}

.container-treinamentos {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 16px;
  width: 100%;
}

.pagination-connection {
  margin-top: 24px;
}

.resultado-busca {
  color: #7A7E83;
  font-size: 18px;
}

.termo-busca {
  font-weight: bold;
}
</style>
